import _ from 'lodash';
export default { execute };

const flightId = 'flightId';
const ADULT = 'ADULT';
const POINTS = 'POINTS';
const AWARD = 'AWARD';
const PUBLIC = 'PUBLIC';

function execute(flights) {
  const flightPriceRequests = _.chain(flights)
    .flatMap(flight =>
      _.map(flight.prices, price => ({
        flightId: flight.id,
        departureFlightAirport: flight.originAirport,
        departureFlightDate: flight.departureDate,
        departureFlightTime: flight.departureTime,
        arrivalFlightAirport: flight.finalDestination,
        operatingCarriers: flight.operatingCarriers,
        cabin: price.category,
        value: price.value,
        currency: price.currency,
        passengerType: price.passenger,
        classType: flight.fareOriginType || price.classType,
        points: flight.points
      }))
    )
    .filter({ passengerType: ADULT })
    .value();
 
    return getPointsBatchByResponse(flightPriceRequests)
    .then(prices => {
      return getAvailableFlights(flights, prices);
    })
    .catch(() => {});


}

function getPointsBatchByResponse(flights) {

  let flightsAvailables = [];

  flights.forEach(flight => {
    const flightBody = {
      cabin: flight.cabin,
      classType: flight.classType,
      flightId: flight.flightId
    };   
   
    const flightAvailable = new Promise(resolve => {      
        if (flight.points && flight.points.value) {               
          resolve({ isAvailable: true, value: flight.points.value, ...flightBody });
        } else {        
          resolve({ isAvailable: false, ...flightBody });
        }     
    });
    flightsAvailables.push(flightAvailable);
  });
  return Promise.all(flightsAvailables);
}


function getAvailableFlights(flights, prices) {
  const availablePrices = removeUnavailableFlights(prices);
  const availablePricesKeys = _.keys(availablePrices);

  return _.chain(flights)
    .filter(
      flight =>
        _.indexOf(availablePricesKeys, flight.id.toString()) > -1
    )
    .map(flight => {
      const prices = availablePrices[flight.id];

      flight.prices = _.concat(
        flight.prices,
        _.map(prices, price => ({
          category: price.cabin,
          passenger: ADULT,
          value: price.value,
          currency: POINTS,
          isAvailable: price.isAvailable
        }))
      );

      return flight;
    })
    .value();
}

function removeUnavailableFlights(prices) {
  let filteredPrices = _.chain(prices)
    .filter(p => p.isAvailable)
    .value();

  return _.chain(filteredPrices)
    .groupBy(flightId)
    .value();
}



// WEBPACK FOOTER //
// ./src/usecases/filterUnavailableFlighs/FilterUnavailableFlights.js